import { render } from "./ToggleList.vue?vue&type=template&id=6b60d2d0"
import script from "./ToggleList.vue?vue&type=script&lang=js"
export * from "./ToggleList.vue?vue&type=script&lang=js"

import exportComponent from "/home/grosscol/workspace/bravue/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__